import React, { useState, Dispatch, useCallback } from 'react';
import { FormControl, Link } from '@material-ui/core';
import { ButtonSubmit, ErrorBlock, PasslyTextField } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import { loginForms } from '@app/enums';
import { handleChangeInputOtp, goBackToList } from '../helpers';

interface IProps {
    onSubmit: (otpCode: string, setIsError: React.Dispatch<boolean>) => Dispatch<React.ChangeEvent<HTMLFormElement>>;
    isLoggingIn: boolean;
    isMultipleProviders: boolean;
    setLoginForm: Dispatch<loginForms>;
}

export const TwoFactorOtp: React.SFC<IProps> = ({ onSubmit, isLoggingIn, isMultipleProviders, setLoginForm }) => {
    const { translation } = useTypedTranslation();

    const [otpCode, setOtpCode] = useState<string>('');
    const [isError, setIsError] = useState<boolean>(false);
    const [emptyFieldError, setEmptyFieldError] = useState(false);
    const handleSubmit = useCallback((otpCode: string, setIsError: React.Dispatch<boolean>) => (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        setEmptyFieldError(!otpCode);

        if (otpCode) {
            onSubmit(otpCode, setIsError)(e);
        }
    }, []);

    return (
        <>
            <div className='otp-signin'>
                <h1>{translation('MFA_OTP_PROVIDER')}</h1>
                <p className='otp-signin__text'>
                    {translation('MFA_OTP_ENTER_PASSCODE')}
                    {isMultipleProviders && (<Link onClick={goBackToList(setLoginForm)}>{translation('MFA_VERIFY_ANOTHER_WAY')}</Link>)}
                </p>
                <ErrorBlock className='otp-signin__error' isError={isError} errorMessage={translation('OTP_VALIDATION_ERROR')} />

                <form onSubmit={handleSubmit(otpCode, setIsError)}>
                    <FormControl fullWidth>
                        <PasslyTextField
                            className='otp-signin__input'
                            label={'MFA_OTP_PASSCODE'}
                            autoFocus
                            required
                            value={otpCode}
                            onChange={handleChangeInputOtp(setOtpCode, setIsError, isError)}
                            id='code-input'
                            error={emptyFieldError}
                            helperText={emptyFieldError && translation('EMPTY_FIELD_ERROR')}
                            fullWidth
                        />
                    </FormControl>
                    <div className='otp-signin__buttons-wrapper'>
                        <ButtonSubmit className='otp-signin__button' isDisabled={isLoggingIn} isLoad={isLoggingIn} buttonText={translation('VERIFY')} />
                    </div>
                </form>
            </div>
        </>
    );
};
